module.exports = "<span class=\"scalarClose\" (click)=\"closeScalar()\">\n    <i class=\"far fa-times-circle\"></i>\n</span>"